import {css} from 'lit';
export const styles = css`:host {
  --avatar-size: 44px;

  display: flex;
  justify-content: space-between;
  padding: var(--card-padding);
  border-bottom: 1px solid var(--border-light-secondary);
}

:host([pinValue]) {
  --link-text-hover: var(--primary-200);

  color: #fff;
  background-color: var(--primary);
  border-top-left-radius: var(--border-radius);
  border-top-right-radius: var(--border-radius);
  border-bottom: none;
}

.content-wrapper {
  display: flex;
  align-items: center;
  min-width: 1px;
}

ef-avatar {
  margin-right: 8px;
}

.content {
  display: flex;
  flex-direction: column;
  line-height: 1.4;
  min-width: 1px;
}

.content a {
    --link-text: var(--card-font-color), var(--dark-text);

    margin-top: 0;

    margin-bottom: 0;
    font-size: var(--font-size-base);
    font-weight: 700;
  }

.info {
  display: flex;
  margin-top: 0;
  margin-bottom: 0;
  font-size: var(--font-size-sm);
  color: var(--card-font-color), var(--dark-text-secondary);
}

.info .divider {
    margin-left: 6px;
    margin-right: 6px;
  }

.info .origin {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

.info xs-timeago {
    min-width: -webkit-fit-content;
    min-width: -moz-fit-content;
    min-width: fit-content;
  }

ef-icon {
  font-size: 1.4em;
  margin-left: 8px;
}

@media (min-width: 500px) {
  .content a {
    font-size: var(--font-size-md);
  }

  .info {
    font-size: var(--font-size-base);
  }
}

/* Temporary style */

:host([isAnnouncement='true']) {
  color: #fff;
  background-color: var(--gray-900);
  border-top-left-radius: var(--border-radius);
  border-top-right-radius: var(--border-radius);
}
`;
export default styles;
